import { USER_PROFILE_TYPE_ENUM, USER_STATUS_ENUM } from '~/enums/Users.enum';

export const USERS_PROFILE_OPTIONS = {
  [USER_PROFILE_TYPE_ENUM[1]]: 'USERS.PROFILE_OPTIONS.ADMIN',
  [USER_PROFILE_TYPE_ENUM[2]]: 'USERS.PROFILE_OPTIONS.COMMERCIAL',
  [USER_PROFILE_TYPE_ENUM[3]]: 'USERS.PROFILE_OPTIONS.MANAGER',
  [USER_PROFILE_TYPE_ENUM[4]]: 'USERS.PROFILE_OPTIONS.FINANCIAL',
  [USER_PROFILE_TYPE_ENUM[5]]: 'USERS.PROFILE_OPTIONS.FINANCIAL_ADMINISTRATOR',
};

export const USERS_STATUS_OPTIONS = {
  [USER_STATUS_ENUM[1]]: 'USERS.STATUS_OPTIONS.ACTIVE',
  [USER_STATUS_ENUM[0]]: 'USERS.STATUS_OPTIONS.INACTIVE',
};

export const USERS_STATUS_COLORS = {
  ACTIVE: 'success',
  INACTIVE: 'error',
};
